export const NOT_AUTHORIZED_MESSAGE =
  "You don't have permission to do this. Contact your administrator if you think this is an error.";
